module.exports = __webpack_public_path__ + "media/omnipharm.22a46e88.mp4";